const defaultConfig = require("./config.default.js");

module.exports = {
  ...defaultConfig,

  projectName: "Senses",

  webfeedDebuggerWebsiteUrl:
    "https://sensesliving.com.au/now-selling#/masterplan",
  webfeedConfig: {
    mode: "masterplan",
    type: "land"
  }
  // add other conf items below if needed
};
